import { ComponentClassNames } from '../../util/classNames';
import { ThemedClickableStyleProps, getLinkClassNames } from '../../util/styles/links';
import { memoizeFunction, mergeStyleSets } from '../../util/styling';

type GetClassNames = (props: ThemedClickableStyleProps) => ComponentClassNames<'clickable'>;
export const getClassNames: GetClassNames = (props) =>
  getClassNamesMemoized(
    props.activeColor,
    props.alwaysUnderline,
    props.className,
    props.color,
    props.colorOverride,
    props.disabled,
    props.display,
    props.focusOutline,
    props.theme
  );

const getClassNamesMemoized = memoizeFunction(
  (
    activeColor: ThemedClickableStyleProps['activeColor'],
    alwaysUnderline: ThemedClickableStyleProps['alwaysUnderline'],
    className: ThemedClickableStyleProps['className'],
    color: ThemedClickableStyleProps['color'],
    colorOverride: ThemedClickableStyleProps['colorOverride'],
    disabled: ThemedClickableStyleProps['disabled'],
    display: ThemedClickableStyleProps['display'],
    focusOutline: ThemedClickableStyleProps['focusOutline'],
    theme: ThemedClickableStyleProps['theme']
  ) =>
    mergeStyleSets({
      clickable: [
        {
          width: display === 'block' ? '100%' : undefined,
          selectors: {
            '> .y-block': {
              width: '100%',
            },
          },
        },
        getLinkClassNames({
          activeColor,
          alwaysUnderline,
          className,
          color,
          colorOverride,
          disabled,
          display,
          focusOutline,
          theme,
          unstyled: true,
        }).link,
      ],
    })
);
